import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProductionInternally from '../../components/ProductionInternally';
import { Route } from 'react-router-dom';
import { PRODUCTIONINTERNALLY } from '../../routes';

const ProductionInternallyRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PRODUCTIONINTERNALLY}
				render={props => <ProductionInternally {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProductionInternallyRoute;
